import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { Modal, ModalFooter } from '@grandvisionhq/common';
import { Util } from '@grandvisionhq/forms';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import { useBaseSummarySlot } from '../../slots/summaries/summary-context.js';
import { updateShippingDetails } from '../../StepShipping/actions.js';
import { getShippingData } from '../../StepShipping/selectors.js';
import { InvoiceFormContainer } from '../../StepShipping/containers/InvoiceFormContainer.js';

const EditableInvoiceSummary = ({ labels  })=>{
    var ref, ref1, ref2;
    const [invoiceFormData, setInvoiceFormData] = React__default.useState();
    const [isModalOpen, setIsModalOpen] = React__default.useState(false);
    const { Slots  } = useBaseSummarySlot();
    const dispatch = useDispatch();
    const invoiceShippingData = (ref = useSelector(getShippingData)) === null || ref === void 0 ? void 0 : ref.invoice;
    const companyShippingData = (ref1 = useSelector(getShippingData)) === null || ref1 === void 0 ? void 0 : ref1.company;
    // companyShippingData also includes invoice summary data(`secondaryEmail` and `recipientCode`) that needs to be mapped
    const invoiceData = swcHelpers.objectSpread({}, invoiceShippingData, {
        secondaryEmail: (invoiceShippingData === null || invoiceShippingData === void 0 ? void 0 : invoiceShippingData.secondaryEmail) || (companyShippingData === null || companyShippingData === void 0 ? void 0 : companyShippingData.secondaryEmail) || '',
        recipientCode: (invoiceShippingData === null || invoiceShippingData === void 0 ? void 0 : invoiceShippingData.recipientCode) || (companyShippingData === null || companyShippingData === void 0 ? void 0 : companyShippingData.recipientCode) || ''
    });
    const hasData = invoiceData && !Object.values(invoiceData).every((x)=>x === null || x === ''
    );
    const InvoiceSummarySlot = Slots.invoice;
    if (!InvoiceSummarySlot && hasData) {
        console.error('This opco is misconfigured. It has invoice data, but no invoice summary card setup.');
    }
    if (!InvoiceSummarySlot || !hasData) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Modal, {
        isOpen: isModalOpen,
        onModalClose: ()=>setIsModalOpen(false)
        ,
        showIcon: true,
        footer: /*#__PURE__*/ React__default.createElement(ModalFooter, {
            ctaCaption: labels === null || labels === void 0 ? void 0 : (ref2 = labels.editModal) === null || ref2 === void 0 ? void 0 : ref2.save,
            onCta: ()=>{
                if (!(invoiceFormData === null || invoiceFormData === void 0 ? void 0 : invoiceFormData.formValid)) {
                    Util.focusToTopErrorFieldOnScreen();
                } else {
                    invoiceFormData && dispatch(updateShippingDetails({
                        form: invoiceFormData
                    }));
                    setIsModalOpen(false);
                }
            },
            onCancel: ()=>setIsModalOpen(false)
        })
    }, /*#__PURE__*/ React__default.createElement(InvoiceFormContainer, {
        onChange: (formData)=>setInvoiceFormData(formData)
    })), hasData && /*#__PURE__*/ React__default.createElement(InvoiceSummarySlot, {
        actions: {
            onEdit: ()=>setIsModalOpen(true)
        },
        values: invoiceData
    }));
};

export { EditableInvoiceSummary, EditableInvoiceSummary as default };
//# sourceMappingURL=EditableInvoiceSummary.js.map
